import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
// Pages
import BlogPage from "./pages/BlogPage";
import SurveysPage from "./pages/SurveysPage";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import StoreList from "./pages/ProductsPage";
import DashboardAppPage from "./pages/DashboardAppPage";
import NewTicket from "./pages/NewTicket";
import ViewSurveys from "./pages/ViewSurveys";
import PublicViewSurvey from "./pages/PublicViewSurvey";
import ReplySurvey from "./pages/ReplySurvey";
import ResetPassword from "./pages/resetPassword/ResetPassword";
// Secure route
import PrivateRoute from "./hooks/Token/PrivateRoute";
import DashboardHomePage from "./pages/Home";
import UserCreateEditPage from "./pages/UserCreateEditPage";
import UsersListPage from "./pages/UsersListPage";
import CustomerListPage from "./pages/CustomerListPage";
import CustomerCreateEditPage from "./pages/CustomerCreateEditPage";
// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/home" />, index: true },
        {
          path: "home",
          element: <PrivateRoute children={<DashboardHomePage />} />,
          index: true,
        },
        // { element: <Navigate to="/dashboard/app" />},
        {
          path: "app",
          element: <PrivateRoute children={<DashboardAppPage />} />,
        },
        {
          path: "ticket",
          element: <PrivateRoute children={<SurveysPage />} />,
        },
        // { path: 'new-ticket', element: <NewTicket /> },
        {
          path: "view-ticket",
          element: <PrivateRoute children={<ViewSurveys />} />,
        },
        {
          path: "reply-ticket",
          element: <PrivateRoute children={<ReplySurvey />} />,
        },
        {
          path: "public-view-ticket/:uuid",
          element: <PublicViewSurvey />,
        },
        // { path: 'store', element: <StoreList /> },
        // { path: 'blog', element: <BlogPage /> },
      ],
    },
    {
      path: "/users",
      element: <DashboardLayout />,
      children: [
        {
          path: "list",
          element: <PrivateRoute children={<UsersListPage />} />,
          index: true,
        },
        {
          path: "create",
          element: <PrivateRoute children={<UserCreateEditPage />} />,
        },
        {
          path: "edit",
          element: <PrivateRoute children={<UserCreateEditPage />} />,
        },
      ],
    },
    {
      path: "/customers",
      element: <DashboardLayout />,
      children: [
        {
          path: "list",
          element: <PrivateRoute children={<CustomerListPage />} />,
          index: true,
        },
        {
          path: "create",
          element: <PrivateRoute children={<CustomerCreateEditPage />} />,
        },
        {
          path: "edit",
          element: <PrivateRoute children={<CustomerCreateEditPage />} />,
        },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      path: "reset/password",
      element: <ResetPassword />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
